import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import dieTypeService from "../services/die-type.service";
import { setMessage } from "./message";
export const fetchDieTypeList = createAsyncThunk(
  'dieType/fetchDieTypeList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await dieTypeService.getDieTypeList(page, pagesize, search, ordering);
      return response.data; // Assuming response contains { data: { users, totalpage, etc. }}
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const fetchArchiveDieTypeList = createAsyncThunk(
    'dieType/fetchArchiveDieTypeList',
    async ({ page, pagesize, search }, thunkAPI) => {
        try {
            const response = await dieTypeService.getDieArchiveTypeList(page, pagesize, search);
            return response.data; // Assuming response contains { data: { users, totalpage, etc. }}
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const createDieType = createAsyncThunk(
  'dieType/createDieType',
  async (categoryData, thunkAPI) => {
    try {
      const response = await dieTypeService.createDieType(categoryData);
      return response.data; // Assuming response contains the created category data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const editDieType = createAsyncThunk(
  'dieType/editDieType',
  async ({ categoryId, categoryData }, thunkAPI) => {
    try {
      const response = await dieTypeService.editDieType(categoryId, categoryData);
      return response.data; // Ensure this returns the updated category data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteDieType = createAsyncThunk(
  'dieType/deleteDieType',
  async (id, thunkAPI) => {
    try {
      await dieTypeService.deleteDieType(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const unArchiveDieType = createAsyncThunk(
    'dieType/unArchiveDieType',
    async (id, thunkAPI) => {
        try {
            await dieTypeService.unArchiveDieType(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);


const initialState = {
  data: [],
  list: [],
  loading: false,
  totalpage: 0,
  currentpage: 1,
  totalRecord: 0,
  status: 'idle',
  error: null,
  hasMore: true,
};

const dieTypeSlice = createSlice({
  name: 'dieType',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetDieTypeList: (state) => {
      state.list = []; // This will clear the list
    },
    resetCurrentDieTypePage: (state) => {
      state.currentpage = 1;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDieTypeList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDieTypeList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentpage;
        state.data = action.payload.results.data || [];  // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchDieTypeList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
      builder
          .addCase(fetchArchiveDieTypeList.pending, (state) => {
              state.status = 'loading';
          })
          .addCase(fetchArchiveDieTypeList.fulfilled, (state, action) => {
              state.status = 'succeeded';
              const fetchedPage = action.payload.page || state.currentpage;
              state.data = action.payload.results.data || [];  // Update to match your API response
              state.totalRecord = action.payload.count || 0; // Handle count (total records)
              state.totalPages = action.payload.totalPages || 0; // Handle totalPages
              state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
              state.list = [...state.list, ...action.payload.results.data];
              state.hasMore = !!action.payload.next;
          })
          .addCase(fetchArchiveDieTypeList.rejected, (state, action) => {
              state.status = 'failed';
              state.loading = false;
              state.error = action.error.message;
          });
    builder
      .addCase(createDieType.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createDieType.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data.push(action.payload);  // Add the newly created category to the list
      })
      .addCase(createDieType.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(editDieType.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const index = state.data.findIndex(category => category.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editDieType.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(deleteDieType.pending, state => {
        state.status = 'loading';
      })
      .addCase(deleteDieType.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
      })
      .addCase(deleteDieType.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
      builder
          .addCase(unArchiveDieType.pending, state => {
              state.status = 'loading';
          })
          .addCase(unArchiveDieType.fulfilled, (state, action) => {
              state.status = 'succeeded';
              state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
          })
          .addCase(unArchiveDieType.rejected, (state, action) => {
              state.status = 'failed';
              state.loading = false;
              state.error = action.error.message;
          });
  },
});

export const { resetDieTypeList, resetCurrentDieTypePage } = dieTypeSlice.actions;
const { reducer } = dieTypeSlice;
export default reducer;
